@if (bemData(); as bemData) {
  <mat-card class="crop-field-card">
    <mat-card-content>
      <div class="crop-field-grid">
        <div class="field-group">
          <div class="field-label">{{ 'BFP.UI.Field_name' | translate }}</div>
          <app-crop-field-selector
            (selectedCropFieldIdChange)="onCropFieldChange($event)"
            [cropFields]="nutrientCalculations()"
            [selectedCropFieldId]="bemData.cropField.id"
          />
        </div>

        <div class="field-group">
          <div class="field-label">{{ 'BFP.UI.Variety' | translate }}</div>
          <mat-form-field
            appearance="fill"
            subscriptSizing="dynamic"
            class="variety-field"
            [matTooltip]="matTooltipText() | translate"
          >
            <mat-select
              id="bem-variety-select"
              [formControl]="varietyControl"
              [attr.aria-label]="'BFP.UI.Variety' | translate"
              [placeholder]="'BFP.UI.Unknown' | translate"
              (selectionChange)="onVarietyChange($event.value)"
            >
              @if (!currentVarietyIsAvailable()) {
                <mat-option [value]="currentVarietyId()" disabled>
                  {{ bemData.cropVariety?.name ?? ('BFP.UI.Unknown' | translate) }}
                </mat-option>
              }
              @if (varietiesLoadFailed()) {
                <mat-option disabled class="variety-load-error">
                  {{ 'BFP.Notifications.VarietiesLoadFailed' | translate }}
                </mat-option>
              } @else {
                @for (variety of availableVarieties(); track variety.id) {
                  <mat-option [value]="variety.id">{{ variety.name }}</mat-option>
                } @empty {
                  <mat-option disabled class="variety-empty">
                    {{ 'BFP.UI.NoAvailableVarieties' | translate }}
                  </mat-option>
                }
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="field-group">
          <div class="field-label">{{ 'BFP.UI.Purpose' | translate }}</div>
          <div class="field-value">
            {{ bemData.productionPurposeCategory?.description ?? ('BFP.UI.Unknown' | translate) }}
          </div>
        </div>

        <div class="field-group">
          <div class="field-label">{{ 'BFP.UI.Planting_date' | translate }}</div>
          <div class="field-value field-value--stacked">
            <div class="plant-date-control-with-warning">
              <mat-form-field
                [matTooltip]="matTooltipText() | translate"
                [ngClass]="{
                  'highlight-empty': !areSampleDatesConfirmed(),
                  'plant-date-field--warning': plantDateWarningCodes().length > 0,
                }"
                appearance="fill"
                matTooltipPosition="above"
                subscriptSizing="dynamic"
              >
                @if (!isPlantDateConfirmed()) {
                  <mat-label>
                    {{ 'BFP.UI.Select_date' | translate }}
                  </mat-label>
                }
                <input
                  (dateChange)="handleSubmitPlantDate($event)"
                  id="bem-plant-date-input"
                  [attr.aria-label]="'BFP.UI.Planting_date' | translate"
                  [formControl]="plantDateFormControl"
                  [matDatepicker]="picker"
                  [min]="plantDateLimits.min"
                  [max]="plantDateLimits.max"
                  class="plant-date"
                  matInput
                />
                <mat-datepicker-toggle [for]="picker" matSuffix />
                <mat-datepicker #picker />
              </mat-form-field>
              @if (plantDateWarningCodes().length > 0) {
                <app-plant-date-warning [warningCodes]="plantDateWarningCodes()"></app-plant-date-warning>
              }
            </div>
          </div>
        </div>

        <div class="field-group crop-year-field">
          <app-crop-year-selector [readOnly]="true" />
        </div>
      </div>
    </mat-card-content>
  </mat-card>
}

@if (error(); as error) {
  <mat-card class="crop-field-card error-card">
    <mat-card-content>
      <div class="crop-year-selector-fallback">
        <app-crop-year-selector [readOnly]="true" />
      </div>
      <agr-notification-empty
        [emptyDescription]="
          (error.title
            ? 'BFP.Validation.Backend.' + error.status + '.CropFieldInfo'
            : 'BFP.Validation.Frontend.InvalidOrMissingCropFieldId'
          ) | translate
        "
        [isEmpty]="true"
        [showEmptyAction]="false"
        emptyActionColor="primary"
      />
    </mat-card-content>
  </mat-card>
}

@if (isLoading()) {
  <!-- Loading state -->
  <mat-card class="crop-field-card">
    <mat-card-content>
      <div class="crop-year-selector-fallback">
        <app-crop-year-selector [readOnly]="true" />
      </div>
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <span>{{ 'BFP.UI.Loading' | translate }}</span>
      </div>
    </mat-card-content>
  </mat-card>
}
